export default __webpack_public_path__ + "static/media/about.a0b71461.md";